import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["sidebar", "overlay"];

  connect() {
    const sidebarTimezone = document.getElementById("sidebar-timezone");
    if (sidebarTimezone && window.AdminUtils) {
      const timezone = window.AdminUtils.getUserTimezone();
      sidebarTimezone.textContent = timezone.split("/").pop();
    }
  }

  toggle() {
    this.sidebarTarget.classList.toggle("open");
    this.overlayTarget.classList.toggle("hidden");
  }

  close() {
    this.sidebarTarget.classList.remove("open");
    this.overlayTarget.classList.add("hidden");
  }
}
